import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const usePagination = ({ page, totalItems, defaultPageSize }) => {
    const [data, setData] = useState([]);
    const [dataSel, setDataSel] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        page: page || 1,
        pageSize: defaultPageSize || 10,
        totalItems: totalItems || 0
    });

    useEffect(() => {
        // Reinicia la paginación a la página 1 si el total de elementos es menor
        // que el producto de la página actual y el tamaño de página. Esto asegura
        // que si el total de elementos cambia y ya no hay suficientes elementos
        // para llenar la página actual, la paginación se restablece a la primera página.
        if (pagination.totalItems < pagination.page * pagination.pageSize)
            setPagination(prevState => ({
                ...prevState,
                page: 1
            }));
    }, [pagination.totalItems]);

    const changePage = (page, pageSize) => {
        setPagination(prevState => ({ ...prevState, page, pageSize }));
    };

    const setTotalItems = (totalItems) => {
        setPagination(prevState => ({ ...prevState, totalItems }));
    }

    const incrementTotalItems = (increment) => {
        setPagination(prevState => ({
            ...prevState,
            totalItems: prevState.totalItems + increment
        }));
    }

    const addElement = (item) => {
        setData(prevState => {
            const currentLength = prevState.length;
            let currentItems = prevState;
            // Quitar el último elemento y agregar el nuevo al principio
            if (currentLength === pagination.pageSize) {
                currentItems = prevState.slice(0, -1);
            }
            return [
                item,
                ...currentItems
            ]
        });
        // Incrementar en uno el contador
        incrementTotalItems(1);
    }

    const updateElement = (item) => {
        setData(prevState =>
            prevState.map(element =>
                (element.id === item.id ? item : element)
            )
        );

    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setData(prevState => ({ ...prevState, [name]: value }));
    }

    return {
        data,
        pagination,
        changePage,
        setData,
        setTotalItems,
        addElement,
        loading,
        setLoading,
        handleChange,
        dataSel,
        setDataSel,
        updateElement
    };
};

usePagination.propTypes = {
    page: PropTypes.number,
    totalItems: PropTypes.number,
    defaultPageSize: PropTypes.number
}

export default usePagination;
